<template>
  <div>
    <div>
      <el-dialog  id="queryNum-dialog"
        :visible.sync="dialogVisible"
        width="1000px"
        title="候租人数"
        :close-on-click-modal="false"
        :lock-scroll="false"
        :append-to-body="true"
      >
      <el-row class="normal-row">
        <el-col :span="4" class="thead">
            区域
        </el-col>
        <el-col :span="20" class="tbody">
            <el-radio-group v-model="formData.streetID">
              <el-radio v-for="(item,index) in streetList" :key="index" :label="item.id" v-on:change="changeStreet(item)">
                {{item.name}}
              </el-radio>
            </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="normal-row">
        <el-col :span="4" class="thead">
            小区
        </el-col>
        <el-col :span="20" class="tbody">
            <el-radio-group v-model="formData.communityID">
              <el-radio v-for="(item,index) in communityList" :key="index" :label="item.id" v-on:change="changeCommunity(item)">
                {{item.name}}
              </el-radio>
            </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="normal-row">
        <el-col :span="4" class="thead">
            房型
        </el-col>
        <el-col :span="20" class="tbody">
            <el-radio-group v-model="formData.roomKindsID">
              <el-radio v-for="(item,index) in roomKindsList" :key="index" :label="item.kindID" v-on:change="changeRoomType(item)">
                {{item.kindName}}
              </el-radio>
            </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="normal-row" v-if="isShowSex">
        <el-col :span="4" class="thead">
            性别
        </el-col>
        <el-col :span="20" class="tbody">
            <el-radio-group v-model="formData.sex">
              <el-radio :label="1" >男</el-radio>
              <el-radio :label="0" >女</el-radio>
            </el-radio-group>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align:center;">
          <el-button type="primary" style="width:120px;" v-on:click="query">查 询</el-button>
        </el-col>
      </el-row>
      <el-row class="error-tip">
         <el-col :span="24">
            <div style="text-align:center;" v-if="success == true">
                您查询的房源队列当前排队人数为<span style="color:red;">{{sequence}}</span>人！排队人数随时可能发生变化，不作为候租依据，仅供参考！
            </div>
            <div style="text-align:center; color:red;" v-else>
                {{errmsg}}
            </div>
         </el-col>
      </el-row>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import PortalApi from "@/api/portal/index";
export default ({
  data(){
    return {
      // 对话框显示和隐藏
        dialogVisible: true,
        isShowSex: false,
        sequence:-1,
        success: false,
        errmsg:"",

        formData : {
            communityID: null,
            roomKindsID: null,
            roomType:"",
            sex: null
        },
        streetList: [],
        communityList: [],
        roomKindsList : []
    }
  },
  methods: {
    handleClose: function (done) {
      done();
    },

    changeStreet: function(item){
      var para = [{id:item.code,type:1,name:""},{id:0,type:7,name:""}];
      PortalApi.getCommunityList(1,500,para)
      .then(
          res=>{
              this.communityList = res.data;
          }
      )
      this.isShowSex = false;
      this.roomKindsList = [];
      this.formData.communityID = null;
      this.success = false;
      this.errmsg = "";
    },

    changeCommunity: function(item){
      PortalApi.getCommunityRoomKinds(item.id).then(
          res=>{
              if(res.data.length > 0){
                this.roomKindsList = res.data.filter(function(ele){return ele.roomTypeList.length > 0});
              }              
          }
      ); 
      this.isShowSex = false;
      this.formData.roomKindsID = null;
      this.success = false;
      this.errmsg = "";
    },
    changeRoomType: function(item){
      if(item.kindType == 0){
        this.isShowSex = true;
      }
      else{
        this.isShowSex = false;        
      }

      this.formData.sex = null;
      this.formData.roomType = item.kindType;
      this.success = false;
      this.errmsg = "";
    },
    getData(){
        PortalApi.getNavInfo()
        .then(
            res=>{
                this.streetList = res.data.streetTownList;
            }
        )
    },
    query(){
      if(this.formData.communityID == null){
          this.errmsg = "请选择小区！";
          return;
      }
      if(this.formData.roomKindsID == null){
          this.errmsg = "请选择房型！";
          return;
      }

      if(this.formData.roomType == 0 && this.formData.sex === null){
          this.errmsg = "合租房请选择性别！";
          return;
      }

      PortalApi.getWaitingNumForPortal(this.formData.communityID,this.formData.roomKindsID, this.formData.sex)
      .then(
        res=>{
          this.success = res.success;
          if(res.success){
            this.sequence = res.data;
          }
        },err=>{
          this.success = false;
          this.errmsg = err;
        }
      )

      return;
    }
  },
  mounted(){
      this.getData();
  },
})
</script>

<style lang="scss">
  #queryNum-dialog .login-title {
    text-align: left;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }

  #queryNum-dialog .el-row {
     padding:10px;
  }

  #queryNum-dialog .error-tip{
    padding: 30px;
    border:1px solid rgba(229,229,229,1);
    background: rgba(248,248,248,1);
    margin:20px auto 20px auto;
    width: 950px;
    
    font-size: 16px;
  }

  #queryNum-dialog .normal-row {
    border-bottom: 1px dashed rgba(220,220,220,1);
  }

  #queryNum-dialog .normal-row .thead{
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(51,51,51,1);
    background: rgba(248,248,248,1);
    text-align: center;
  }

  #queryNum-dialog .normal-row .tbody {
    display: flex;
    padding: 10px;
  }

  #queryNum-dialog .el-radio{
    width:150px;
  }
</style>
